import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./index.css";
import image from "../../assets/images/Rectangle2.PNG";
import aboutusBackground from "../../assets/images/AboutUs.PNG";
import logo from "../../assets/images/Logo2.PNG";
import AboutUs1 from "../../assets/images/AboutUs1.PNG";
import AboutUs2 from "../../assets/images/AboutUs2.PNG";
import AboutUs3 from "../../assets/images/AboutUs3.PNG";
import AboutUs4 from "../../assets/images/AboutUs4.PNG";
import img1 from "../../assets/images/about-us-im1.PNG";
import img2 from "../../assets/images/about-us-im2.PNG";
import img3 from "../../assets/images/about-us-im3.PNG";
import img4 from "../../assets/images/about-us-im4.PNG";
// import readyToFeast from '../../assets/images/ReadytoFeast2.PNG';
import readyToFeast from "../../assets/images/ReadytoFeast3.PNG";
import aboutusimg1 from "../../assets/images/aboutusimg1.PNG";
import aboutusimg2 from "../../assets/images/aboutusimg2.PNG";
import aboutusimg3 from "../../assets/images/aboutusimg3.PNG";
import ContactInfoButton from "../../components/EmailButtonComponent";
import EmailSVG from "../../assets/icons/emailIcon.PNG";
import PhoneSVG from "../../assets/icons/phoneIcon.PNG";
const AboutUs = () => {
  return (
    <>
      <div className="about-us-top-container">
        <header
          className="about-us"
          style={{
            background: aboutusBackground,
          }}
        >
          <Container className="text-start">
            <h1>About Us</h1>
            <p>
              Curry King is Sri Lanka’s first technology-powered rice and curry
              brand, delivering freshly cooked, ready-to-eat meals inspired by
              the island’s rich culinary heritage. Designed for busy city life,
              our meals bring the flavours of home to your hands—convenient,
              consistent, and cooked with care
            </p>
          </Container>
          <Container className="d-flex justify-content-between align-items-center"></Container>
        </header>
      </div>
      <div className="about-us-section">
        <div className="d-flex flex-column align-items-center justify-content-center text-center p-5">
          <img src={logo} alt="Logo" className="logo" />
          <h2 className="fw-bold py-3">Who We Are</h2>
          <p className="fw-bold">
            We are a multidisciplinary team of chefs, engineers, technologists,
            and food safety experts united by a mission: to make authentic Sri
            Lankan rice and curry accessible to everyone. Headquartered in
            Colombo, our central kitchen combines traditional recipes with smart
            automation to serve thousands of people every day across offices,
            homes, and institutions.
          </p>
        </div>
        <div className="d-flex align-items-center justify-content-center text-center p-5 gap-5">
          <img src={AboutUs1} alt="About Us 1" className="about-us-image" />
          <img src={AboutUs2} alt="About Us 2" className="about-us-image" />
          <img src={AboutUs3} alt="About Us 3" className="about-us-image" />
          <img src={AboutUs4} alt="About Us 4" className="about-us-image" />
        </div>
      </div>
      <div>
        <Container fluid className="p-4 what-we-offer">
          <Row className="align-items-center bg-light p-2">
            <Col
              md={6}
              className="p-5 d-flex flex-column justify-content-center "
            >
              <h1 className="fw-bold text-dark">What We Offer</h1>
              <p className="text-muted">
                Our signature ready-to-eat lunch packs are made daily using
                locally sourced rice, vegetables, and proteins. Available in
                four value categories—Bronze, Silver, Gold, and Platinum—each
                pack is hygienically cooked, sealed, and delivered through our
                fleet of mobile food carts or ordered via our app and website.
              </p>

              <h4 className="fw-bold">Each Curry King Meal is</h4>
              <Row className="mb-2 d-flex align-items-center">
                <Col lg="1">
                  <img src={img1} alt="Icon" className="icon" />
                </Col>
                <Col>Cooked fresh every morning for Lunch</Col>
              </Row>
              <Row className="mb-2 d-flex align-items-center">
                <Col lg="1">
                  <img src={img2} alt="Icon" className="icon" />
                </Col>
                <Col>Packed in eco-friendly, sealed containers</Col>
              </Row>
              <Row className="mb-2 d-flex align-items-center">
                <Col lg="1">
                  <img src={img3} alt="Icon" className="icon" />
                </Col>
                <Col>
                  Delivered through carts, pickup points, and pre-orders
                </Col>
              </Row>
              <Row className="mb-2 d-flex align-items-center">
                <Col lg="1">
                  <img src={img4} alt="Icon" className="icon" />
                </Col>
                <Col>Priced for daily affordability</Col>
              </Row>
            </Col>
            <Col md={6} className="text-center">
              <Image
                src={image}
                alt="Healthy food bowl"
                fluid
                className="rounded shadow"
              />
            </Col>
          </Row>
        </Container>
      </div>
      <div className="our-promise-container">
        <h2 className="fw-bold">What We Stand For</h2>
        <div className="promise-cards">
          <div className="promise-card">
            <div className="icon-container">
              <img src={aboutusimg1} alt="icon" />
            </div>
            <h4>Our Technology</h4>
            <p>
              We don’t just cook—we engineer consistency. Our production
              facility is powered by advanced robotics, which automate cooking,
              tray filling, sealing, and dispatch. At the core of our operations
              is a proprietary recipe management system that read more
            </p>
          </div>
          <div className="promise-card">
            <div className="icon-container">
              <img src={aboutusimg2} alt="icon" />
            </div>
            <h4>Our Commitment</h4>
            <p>
              We believe that great food should never be a luxury. By combining
              technology, local sourcing, and scalable systems, Curry King
              delivers a daily meal that is honest, clean, and rooted in
              tradition—ready to eat, wherever you are.
            </p>
          </div>
          <div className="promise-card">
            <div className="icon-container">
              <img src={aboutusimg3} alt="icon" />
            </div>
            <h4>Sustainability Promise</h4>
            <p>
              We are committed to responsible operations—from sourcing
              ingredients to delivering meals. Our packaging is biodegradable or
              recyclable, and our systems are designed to minimize food waste
              and energy consumption.
            </p>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 position-relative">
            <div className="ready-to-feast-image-wrapper">
              {/* <img
                                src={readyToFeast}
                                alt="Ready to Feast"
                                className="img-fluid rounded-3"
                            /> */}
              <img
                src={readyToFeast}
                alt="Ready to Feast"
                className="img-fluid rounded-3 mb-4"
              />

              <div className="overlay-text text-white text-center">
                <h1 className="display-4 fw-bold">
                  We’re Always there for you
                </h1>
                <p className="lead">
                  If you have any questions regarding these policies or require
                  further clarification, please contact us at:
                </p>
                <div className="contact-button-row mb-3 ">
                  <ContactInfoButton
                    icon={EmailSVG}
                    title="Email Us"
                    subtitle="support@curryking.lk"
                  />
                  <ContactInfoButton
                    icon={PhoneSVG}
                    title="Call for Information"
                    subtitle="+94 11 444 1333"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
